import { useEffect, useMemo, useState } from 'react';

import { ControlPosition } from '@vis.gl/react-google-maps';
import {
  Map,
  MapProvider,
  UserLocationControl,
  ZoomControl,
  useBreakPoints,
  useMap,
  useUserLocation,
} from 'core';
import { Container, LoadingOverlay, SwipeableContainerProvider } from 'ui';
import { useDebouncedCallback, useElementSize } from 'ui/Hooks';

import { ActivateAllOffersMapControl } from '../components/ActivateAllOffersButton';
import { InStoreMerchantMarkers } from './InStoreMerchantMarkers';
import { LocalMerchantSearch } from './InStoreMerchantSearch/InStoreMerchantSearch';
import { MapLocationProvider } from './mapLocation.provider';

const EarnInStoreMap = () => {
  const { isMediumScreen } = useBreakPoints();

  const { geolocation, isStatusLoading } = useUserLocation();
  // if we have the users location we can center the map on them
  const _geolocation = useMemo(
    () => (geolocation ? { lat: geolocation.latitude, lng: geolocation.longitude } : undefined),
    [geolocation]
  );
  if (!isStatusLoading) return <LoadingOverlay visible={true} />;
  return (
    <Map
      style={{
        width: '100vw',
        height: isMediumScreen
          ? 'calc(100dvh - var(--app-shell-header-height) - 40px - calc(var(--app-shell-padding) * 3) )' // 100dvh - header height - toggle height - (app shell padding, and marginTop from below)
          : 'calc(100dvh - var(--app-shell-header-height))',
        // Add padding to the top of the map to account for the earn toggle
        marginTop: isMediumScreen ? 'calc(var(--app-shell-padding) * 2)' : undefined,
      }}
      defaultCenter={_geolocation}
    >
      <ZoomControl controlPosition={ControlPosition.LEFT_TOP} />
      <UserLocationControl controlPosition={ControlPosition.LEFT_TOP} />
      {/* there isn't a use case for this  */}
      {/* <SearchAreaControl controlPosition={ControlPosition.TOP_CENTER} onSearch={() => null} /> */}
      <ActivateAllOffersMapControl controlPosition={ControlPosition.TOP_CENTER} />
      <InStoreMerchantMarkers />
    </Map>
  );
};

const EarnInStoreContent = () => {
  const [[lat, lng], setLatLong] = useState([0, 0]);
  const { useMapEvent, getMapCenter } = useMap();

  const handleMapChange = useDebouncedCallback(() => {
    const center = getMapCenter();
    if (!center) return;
    setLatLong([center.lat, center.lng]);
  }, 500);

  useMapEvent({ mapEvent: 'center_changed', cb: handleMapChange });

  useEffect(() => {
    const setInitialLatLong = () => {
      const center = getMapCenter();
      if (!center) return;
      setLatLong([center.lat, center.lng]);
    };

    setInitialLatLong();
  }, [getMapCenter]);

  return (
    <MapLocationProvider value={{ lat, lng }}>
      <LocalMerchantSearch />
      <EarnInStoreMap />
    </MapLocationProvider>
  );
};

const EarnInStore = () => {
  const { ref, height } = useElementSize();
  return (
    <SwipeableContainerProvider value={{ containerHeight: height }}>
      <Container
        style={{
          marginTop: 'calc(var(--app-shell-padding) * -1)',
          marginBottom: 'calc(var(--app-shell-padding) * -1)',
          marginLeft: 'calc(var(--app-shell-padding) * -1 )',
          padding: '0px',
        }}
        fluid
        ref={ref}
        pt={{ base: 'md', sm: '0px' }}
      >
        <MapProvider id={'earn'}>
          <EarnInStoreContent />
        </MapProvider>
      </Container>
    </SwipeableContainerProvider>
  );
};

export { EarnInStore };
